import i18nCore from '@tencent/ti18n-i18ncore';

const isNumber = v => '[object Number]' === Object.prototype.toString.call(v);

const cookie = {
  set(sName, _sValue, iExpireSec, sDomain, sPath, bSecure) {
    let sValue = _sValue;

    if (sName === undefined) {
      return;
    }

    if (sValue === undefined) {
      sValue = '';
    }

    const oCookieArray = [`${sName}=${escape(sValue)}`]; // 过期时间必须是数字，且不是NaN

    if (isNumber(iExpireSec) && !isNaN(iExpireSec)) {
      const oDate = new Date();
      oDate.setTime(oDate.getTime() + iExpireSec * 1000);
      iExpireSec === 0 ? '' : oCookieArray.push(`expires=${oDate.toGMTString()}`);
    }

    if (sDomain !== undefined) {
      oCookieArray.push(`domain=${sDomain}`);
    }

    if (sPath !== undefined) {
      oCookieArray.push(`path=${sPath}`);
    }

    if (bSecure) {
      oCookieArray.push('secure');
    }

    document.cookie = oCookieArray.join('; ');
  },

  /**
  * 获取cookie
  * @param {string} sName cookie名
  * @param {string} sValue 默认值
  * @return {string} cookie值
  */
  get(sName, sDefaultValue) {
    const sRE = `(?:; |^)${sName}=([^;]*);?`;
    const oRE = new RegExp(sRE);

    if (oRE.test(document.cookie)) {
      return unescape(RegExp.$1);
    }

    return sDefaultValue || null;
  },

  /**
  * 获取cookie
  * @param {string} sName cookie名
  * @param {string} sDomain 作用域
  * @param {sPath} sPath 作用路径
  * @return {void}
  */
  clear(sName, sDomain, sPath) {
    const oDate = new Date();
    cookie.set(sName, '', -oDate.getTime() / 1000, sDomain, sPath);
  }

};

const isObject = v => 'object' === typeof v;

const isString = v => 'string' === typeof v;

const url = {
  getHashParam(key, url) {
    if (!key) {
      return '';
    }

    const oParams = this.getAllHashParams(url);

    if (oParams && isObject(oParams)) {
      return oParams[key];
    }

    return '';
  },

  getAllHashParams(url) {
    const href = url || location.href;
    let oHashParams = null;

    if (/#.+/.test(href)) {
      const sHashParams = href.substr(href.indexOf('#') + 1);
      const arrHashParams = sHashParams.split('&');

      for (let i = 0; i < arrHashParams.length; i++) {
        const hash = arrHashParams[i];

        if (/.+=.+/.test(hash)) {
          const splitIndex = hash.indexOf('=');
          const k = hash.substring(0, splitIndex);
          const v = hash.substring(splitIndex + 1);

          if (!oHashParams) {
            oHashParams = {};
          }

          oHashParams[k] = v;
        }
      }
    }

    return oHashParams;
  },

  getQueryParam(key, url) {
    if (!key) {
      return '';
    }

    const oParams = this.getAllQueryParams(url);

    if (oParams && isObject(oParams)) {
      return oParams[key];
    }

    return '';
  },

  getAllQueryParams(url) {
    const href = url || location.href;
    let oQueryParams = null;

    if (/\?.+/.test(href)) {
      let sQueryParams = href.substr(href.indexOf('?') + 1);

      if (sQueryParams.indexOf('#') > -1) {
        sQueryParams = sQueryParams.substring(0, sQueryParams.indexOf('#'));
      }

      const arrQueryParams = sQueryParams.split('&');

      for (let i = 0; i < arrQueryParams.length; i++) {
        const query = arrQueryParams[i];

        if (/.+=.+/.test(query)) {
          const splitIndex = query.indexOf('=');
          const k = query.substring(0, splitIndex);
          const v = query.substring(splitIndex + 1);

          if (!oQueryParams) {
            oQueryParams = {};
          }

          oQueryParams[k] = v;
        }
      }
    }

    return oQueryParams;
  },

  /*
  oParams:{
  	query:{
  		k1:v1,
  		k2:v2
  	},
  	hash:{
  		k1:v1,
  		k2:v2
  	}
  }
  */
  mergeUrl(_oParams, _originalUrl) {
    const oParams = _oParams;
    let originalUrl = _originalUrl;

    if (!originalUrl) {
      originalUrl = location.href;
    }

    if (!isObject(oParams)) {
      return originalUrl;
    }

    const oParse = this.parseUrl(originalUrl);
    let {
      oQuery,
      oHash
    } = oParse;

    if (!oQuery) {
      oQuery = oParams.query;
    } else if (oParams.query) {
      Object.keys(oParams.query).forEach(k => {
        oQuery[k] = oParams.query[k];
      });
    }

    if (!oHash) {
      oHash = oParams.hash;
    } else if (oParams.hash) {
      Object.keys(oParams.hash).forEach(k => {
        oHash[k] = oParams.hash[k];
      });
    }

    oParse.oQuery = oQuery;
    oParse.oHash = oHash;
    return this.stringifyUrl(oParse);
  },

  // url => object
  // 解析一个url成{protocol,host,port,pathname,query,hash,其中query，hash也是object}
  parseUrl(_url) {
    let url = _url;
    let oParseRes = null;

    if (!url) {
      url = location.href;
    }

    if (!isString(url)) {
      return oParseRes;
    }

    const matchResult = url.match(/^((https?:)?\/\/)?(\w+(\.\w+)+)(:\d+)?([^?^#]+)?(\?[^#]+)?(#.+)?$/);

    if (!matchResult) {
      return oParseRes;
    }

    oParseRes = {}; // protocol

    if (matchResult[2]) {
      oParseRes.protocol = matchResult[2];
    } else {
      oParseRes.protocol = 'http:';
    } // host


    if (matchResult[3]) {
      oParseRes.host = matchResult[3];
    } else {
      oParseRes.host = '';
    } // port


    if (matchResult[5]) {
      oParseRes.port = matchResult[5].substr(1);
    } else {
      // oParseRes.port= ('https:' == oParseRes.protocol?'443':'80');
      oParseRes.port = '';
    } // pathname


    if (matchResult[6]) {
      oParseRes.pathname = matchResult[6];
    } else {
      oParseRes.pathname = '';
    } // query


    if (matchResult[7]) {
      const sTemp = matchResult[7].substr(1);
      const arrTemp = sTemp.split('&');
      let oQuery = null;

      for (let i = 0; i < arrTemp.length; i++) {
        const query = arrTemp[i];

        if (/.+=.+/.test(query)) {
          const splitIndex = query.indexOf('=');
          const k = query.substring(0, splitIndex);
          const v = query.substring(splitIndex + 1);

          if (!oQuery) {
            oQuery = {};
          }

          oQuery[k] = v;
        }
      }

      oParseRes.sQuery = sTemp;
      oParseRes.oQuery = oQuery;
    } else {
      oParseRes.sQuery = '';
      oParseRes.oQuery = null;
    } // hash


    if (matchResult[8]) {
      const sTemp = matchResult[8].substr(1);
      const arrTemp = sTemp.split('&');
      let oHash = null;

      for (let i = 0; i < arrTemp.length; i++) {
        const hash = arrTemp[i];

        if (/.+=.+/.test(hash)) {
          const splitIndex = hash.indexOf('=');
          const k = hash.substring(0, splitIndex);
          const v = hash.substring(splitIndex + 1);

          if (!oHash) {
            oHash = {};
          }

          oHash[k] = v;
        }
      }

      oParseRes.sHash = sTemp;
      oParseRes.oHash = oHash;
    } else {
      oParseRes.sHash = '';
      oParseRes.oHash = null;
    }

    return oParseRes;
  },

  // object =》 url
  stringifyUrl(oUrlParams) {
    if (!oUrlParams) {
      return '';
    }

    const protocol = oUrlParams.protocol || 'http:';
    const {
      host
    } = oUrlParams;
    const port = oUrlParams.port ? `:${oUrlParams.port}` : '';
    const {
      pathname
    } = oUrlParams;
    let query = '';

    if (oUrlParams.oQuery) {
      const arrQuery = [];
      Object.keys(oUrlParams.oQuery).forEach(k => {
        arrQuery.push(`${k}=${oUrlParams.oQuery[k]}`);
      });
      query = `?${arrQuery.join('&')}`;
    }

    let hash = '';

    if (oUrlParams.oHash) {
      const arrHash = [];
      Object.keys(oUrlParams.oHash).forEach(k => {
        arrHash.push(`${k}=${oUrlParams.oHash[k]}`);
      });
      hash = `#${arrHash.join('&')}`;
    }

    return `${protocol}//${host}${port}${pathname}${query}${hash}`;
  }

};

/*
loaclstorage操作接口
*/
const checkSupport = () => {
  let isSupport;

  try {
    isSupport = window !== 'undefined' && window.localStorage !== null;
    window.localStorage.setItem('ti18n.testen.lng', 'foo');
    window.localStorage.removeItem('ti18n.testen.lng');
  } catch (e) {
    isSupport = false;
  }

  return isSupport;
};

const isSupportStorage = checkSupport();
const storage = {
  isSupport() {
    return isSupportStorage;
  },

  get(key) {
    if ('string' === typeof key && key) {
      try {
        return isSupportStorage && window.localStorage.getItem(key) || '';
      } catch (err) {
        return new Error('not support');
      }
    } else {
      return '';
    }
  },

  setOne(k, v) {
    if (!isSupportStorage) {
      return 'not support';
    }

    if ('string' === typeof k && k) {
      try {
        window.localStorage.setItem(k, v);
      } catch (err) {
        return err;
      }
    }
  },

  setBundle(obj) {
    if ('object' !== typeof obj) {
      return 'not a bundle';
    }

    obj.forEach(k => {
      this.setOne(k, obj[k]);
    });
  },

  set(k, v) {
    if ('object' === typeof k && 'undefined' === typeof v) {
      return this.setBundle(k);
    }

    return this.setOne(k, v);
  },

  remove(key) {
    if ('string' === typeof key) {
      try {
        window.localStorage.removeItem(key);
      } catch (err) {
        return err;
      }
    }
  }

};

const isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

/*
cookie跟踪器
*/
var cookieDetector = {
  detectorName: 'cookie',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {
    key: 'ti18nLng',
    iExpires: 3600,
    // 默认1小时过期
    sDomain: location.host,
    // 默认当前域名
    sPath: '/' // 默认/

  },

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };
  },

  lookup() {
    const {
      key
    } = this.options;
    const data = cookie.get(key);
    return data;
  },

  cacheUserLanguage(lng) {
    const {
      key,
      iExpires,
      sDomain,
      sPath
    } = this.options;
    cookie.set(key, lng, iExpires, sDomain, sPath);
  }

};

/*
htmlTag跟踪器
*/
var htmlTagDetector = {
  detectorName: 'htmlTag',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {
    key: 'lang',
    htmlTag: null
  },

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };

    if (!this.options.htmlTag) {
      this.options.htmlTag = typeof document !== 'undefined' ? document.documentElement : null;
    }
  },

  lookup() {
    let data = '';
    const {
      htmlTag
    } = this.options;

    if (htmlTag && 'function' === typeof htmlTag.getAttribute) {
      data = htmlTag.getAttribute('lang');
    }

    return data || '';
  }

};

/*
navigator跟踪器
*/
const navigatorDetector = {
  detectorName: 'navigator',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {},

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };
  },

  lookup() {
    if (window.navigator && window.navigator.language) {
      return window.navigator.language;
    }

    return '';
  }

};

/*
storage跟踪器
*/
var storageDetector = {
  detectorName: 'localStorage',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {
    key: 'ti18nLng'
  },

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };
  },

  lookup() {
    const {
      key
    } = this.options;
    const data = storage.get(key);
    return data;
  },

  cacheUserLanguage(lng) {
    const {
      key
    } = this.options;
    storage.set(key, lng);
  }

};

/*
hash跟踪器
*/
var urlHashDetector = {
  detectorName: 'hash',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {
    key: 'ti18nLng'
  },

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };
  },

  lookup() {
    const {
      key
    } = this.options;
    const data = url.getHashParam(key);
    return data || '';
  }

};

/*
hash跟踪器
*/
var urlQueryDetector = {
  detectorName: 'querystring',
  // 跟踪器名
  type: 'sync',
  // 同步方式
  options: {
    key: 'ti18nLng'
  },

  init(options = {}) {
    this.options = { ...this.options,
      ...options
    };
  },

  lookup() {
    const {
      key
    } = this.options;
    const data = url.getQueryParam(key);
    return data || '';
  }

};

/*
all detectors
*/
var allDetectors = {
  cookie: cookieDetector,
  htmlTag: htmlTagDetector,
  navigator: navigatorDetector,
  localStorage: storageDetector,
  hash: urlHashDetector,
  querystring: urlQueryDetector
};

/*
@module languageDetector
@description 提供一个跟踪当前语言的机制
*/

class LanguageDetector {
  constructor(options) {
    this.options = { ...options
    };
    this.type = 'languageDetector';
    this.async = false; // languageDetector 默认配置

    this.detectionOptions = {
      order: ['hash', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'ti18nLng',
      lookupHash: 'ti18nLng',
      lookupCookie: 'ti18nLng',
      lookupLocalStorage: 'ti18nLng',
      // cache user language
      caches: ['localStorage', 'cookie'],
      // 标示要使用的跟踪器
      use: ['hash', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'] // iCookieExpires: 86400,
      // sCookieDomain: 'myDomain'

    };
    this.detectors = [];
  }

  init(services, detectionOptions = {}, i18nCoreOptions = {}) {
    this.services = services;
    this.detectionOptions = { ...this.detectionOptions,
      ...detectionOptions
    };
    this.i18nCoreOptions = i18nCoreOptions;
    const {
      use
    } = this.detectionOptions;
    use.forEach(detectorName => {
      this.addDetector(allDetectors[detectorName]);
    });
  }

  addDetector(detector) {
    if (!detector) {
      return;
    }

    const {
      detectorName
    } = detector;
    const {
      lookupQuerystring,
      lookupHash,
      lookupCookie,
      lookupLocalStorage,
      iCookieExpires,
      sCookieDomain
    } = this.detectionOptions;
    let initOption = {};

    if ('cookie' === detectorName) {
      if (lookupCookie) {
        initOption = { ...initOption,
          key: lookupCookie
        };
      }

      if (iCookieExpires) {
        initOption = { ...initOption,
          iExpires: iCookieExpires
        };
      }

      if (sCookieDomain) {
        initOption = { ...initOption,
          sDomain: sCookieDomain
        };
      }
    } else if ('querystring' === detectorName) {
      if (lookupQuerystring) {
        initOption = { ...initOption,
          key: lookupQuerystring
        };
      }
    } else if ('hash' === detectorName) {
      if (lookupHash) {
        initOption = { ...initOption,
          key: lookupHash
        };
      }
    } else if ('localStorage' === detectorName) {
      if (lookupLocalStorage) {
        initOption = { ...initOption,
          key: lookupLocalStorage
        };
      }
    }

    detector.init(initOption);
    this.detectors[detectorName] = detector;
  }
  /*
  @param detectionOrder
  @desc 指定跟踪顺序，如果有值，会覆盖当前的detectionOptions.order
  */


  detect(_detectionOrder) {
    const detectionOrder = _detectionOrder || this.detectionOptions.order;
    const {
      detectors
    } = this;
    const arrDetected = []; // 获取detect

    detectionOrder.forEach(detectorName => {
      if (detectors[detectorName]) {
        const lookup = detectors[detectorName].lookup();

        if (lookup) {
          arrDetected.push(lookup);
        }
      }
    }); // 调用语言处理器处理标准化语言

    let foundLng = '';

    for (let i = 0; i < arrDetected.length; i++) {
      const detectedLng = arrDetected[i];
      const cleanedLng = this.services.languageUtils.formatLanguageCode(detectedLng);

      if (this.services.languageUtils.isWhitelisted(cleanedLng)) {
        foundLng = cleanedLng;
        break;
      }
    }

    return foundLng || this.i18nCoreOptions.fallbackLng[0];
  }
  /*
  @param {string} lng  :缓存指定的语言到跟踪器中
  @param {array} caches: 指定的跟踪器，如果指定会覆盖detectionOptions.caches
  */


  cacheUserLanguage(lng, _caches) {
    const caches = _caches || this.detectionOptions.caches; // 每个缓存都设置一下

    caches.forEach(detectorName => {
      if (this.detectors[detectorName] && 'function' === typeof this.detectors[detectorName].cacheUserLanguage) {
        this.detectors[detectorName].cacheUserLanguage(lng);
      }
    });
  }

}

var languageDetector = new LanguageDetector();

// ====loader 基本加载器
const loader = {
  /**
     * 加载脚本基础方法
     * @private
     * @param {string} filepath 路径
     * @param {function} callback 回调方法
     * @return {undefined} undefined
     */
  loadScript(_url, callback) {
    const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
    let options = {};

    if (typeof _url === 'object') {
      options = _url;
    } else {
      options = {
        url: _url
      };
    }

    let {
      url
    } = options;
    options.timeout = options.timeout || 0; // 0代表没有超时机制
    // callback = callback || s.success;

    const sRefresh = 0 === options.sRefresh ? '' : options.sRefresh || new Date().getTime();
    const script = document.createElement('script');
    script.async = options.async || false;
    script.type = 'text/javascript';
    script.charset = options.charset || '';

    if (sRefresh) {
      url = `${url + (/\?/.test(url) ? '&' : '?')}_=${sRefresh}`;
    }

    script.src = url;
    head.insertBefore(script, head.firstChild);
    let timeout;

    if (0 !== options.timeout) {
      timeout = setTimeout(() => {
        head.removeChild(script);
        callback && callback(false);
      }, options.timeout || 30000);
    } // onload event


    loader.onload(script, () => {
      head.removeChild(script);
      clearTimeout(timeout);
      callback && callback(true);
    }); // onerror event

    loader.onerror(script, () => {
      head.removeChild(script);
      clearTimeout(timeout);
      callback && callback(false);
    });
  },

  /**
     * 加载样式基础方法
     * 暂不处理加载的情况，均认为加载成功。
     * @private
     */
  loadCSS(url, callback) {
    const [head] = document.getElementsByTagName('head');
    const link = head.appendChild(document.createElement('link'));
    link.href = url;
    link.rel = 'stylesheet';
    callback.call(this, true);
  },

  loadCssText(cssText) {
    const cssDom = document.createElement('style');
    cssDom.setAttribute('type', 'text/css');
    const textNode = document.createTextNode(cssText);
    cssDom.append(textNode);
    document.getElementsByTagName('head')[0].append(cssDom);
  },

  onload(_node, callback) {
    const node = _node;
    const isImpOnLoad = 'onload' in node ? true : function () {
      node.setAttribute('onload', '');
      return typeof node.onload === 'function';
    }();

    if (document.addEventListener) {
      node.addEventListener('load', function () {
        callback.call(this, node);
      }, false);
    } else if (!isImpOnLoad) {
      node.attachEvent('onreadystatechange', function () {
        const rs = node.readyState.toLowerCase();

        if (rs === 'loaded' || rs === 'complete') {
          node.detachEvent('onreadystatechange');
          callback.call(this, node.innerHTML);
        }
      });
    }
  },

  onerror(_node, callback) {
    const node = _node;

    if (document.addEventListener) {
      node.addEventListener('error', function () {
        callback.call(this, node);
      }, false);
    } else if ('onerror' in node) {
      node.onerror = function () {
        callback.call(this, node);
      };
    }
  }

};

/**
 * 获取对象类型
 * @private
 * @param {object} object 对象
 * @return {string} 类型
 * 可判断类型：Boolean Number String Function Array Date RegExp Object
 */
function getParamType(obj) {
  return obj === null ? String(obj) : Object.prototype.toString.call(obj).replace(/\[object\s+(\w+)\]/i, '$1') || 'object';
} // ====varType 类型判断 类


const type = {
  /**
     * 判断对象是否定义
     * 其实只对对象中的元素判断有效，如是纯变量，此方法会无法调用，需要外面加try
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isUndefined(o) {
    return o === undefined && typeof o === 'undefined';
  },

  /**
     * 判断对象是否数组
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isArray(obj) {
    return getParamType(obj).toLowerCase() === 'array';
  },

  /**
     * 判断对象是否函数
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isFunction(obj) {
    return getParamType(obj).toLowerCase() === 'function';
  },

  /**
     * 判断对象是否对象
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isObject(obj) {
    return getParamType(obj).toLowerCase() === 'object';
  },

  /**
     * 判断对象是否数值
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isNumber(obj) {
    return getParamType(obj).toLowerCase() === 'number';
  },

  /**
     * 判断对象是否字符串
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isString(obj) {
    return getParamType(obj).toLowerCase() === 'string';
  },

  /**
     * 判断是否布尔值
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isBoolean(obj) {
    return getParamType(obj).toLowerCase() === 'boolean';
  },

  /**
     * 判断对象是否日期
     * @param {object} object 对象
     * @return {bool} 是/否
     */
  isDate(obj) {
    return getParamType(obj).toLowerCase() === 'date';
  },

  /**
     * 判断对象是否DOM元素
     * @param {object} obj DOM对象
     * @return {bool} 是/否
     */
  isDom(obj) {
    try {
      return obj && typeof obj === 'object' && !type.isUndefined(obj.nodeType) && obj.nodeType === 1 && !type.isUndefined(obj.nodeName) && typeof obj.nodeName === 'string';
    } catch (e) {
      // console.log(e)
      return false;
    }
  },

  /**
     * 获取DOM对象的值
     * @param {object} obj DOM对象
     * @return {string} 取value或innerHTML
     */
  getDomVal(obj) {
    return obj.value || obj.innerHTML;
  },

  /**
     * 索引序列
     * @param {serial,function} 数组或对象集合
     * @return {undefined}
     */
  forEach(haystack, callback) {
    let i = 0;
    const {
      length
    } = haystack;

    if (length !== undefined) {
      for (; i < length;) {
        if (callback.call(haystack[i], i, haystack[i]) === false) {
          break;
        }

        i += 1;
      }
    } else {
      Object.keys(haystack).forEach(name => {
        callback.call(haystack[name], name, haystack[name]);
      });
    }
  },

  /**
     * 获取dom对象
     * @param {string|dom} dom的id或对象k
     * @return {dom}
     */
  g(obj) {
    return typeof obj === 'object' ? obj : document.getElementById(obj);
  }

};

// network 网络请求相关

let xmlRequestId = 0;
const xmlRequestPool = {}; // 请求池

const createXMLRequest = () => {
  let xhr = null;

  try {
    xhr = new window.XMLHttpRequest();
  } catch (e) {
    xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
  }

  if (xhr) {
    xmlRequestId += 1;
    xmlRequestPool[xmlRequestId] = {
      xhr
    };
  }

  return {
    xmlRequestId,
    xhr
  };
};

const xhrSuccessStatus = {
  // File protocol always yields status code 0, assume 200
  0: 200,
  // Support: IE <=9 only
  // #1450: sometimes IE returns 1223 when it should be 204
  1223: 204
};

const parseAjaxData = (response, dataType) => {
  let data = null;
  let error = '';

  try {
    if ('text' === dataType) {
      data = response.text;
    } else if ('json' === dataType) {
      data = JSON.parse(response.text);
    }
  } catch (e) {
    error = e;
  }

  return {
    data,
    error
  };
};

const network = {
  // get方式
  get(_url, _options) {
    let url = _url;
    let options = _options || {};

    if (type.isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    }

    options.type = 'GET';
    return this.ajax(options);
  },

  // post方式
  post(_url, _options) {
    let url = _url;
    let options = _options || {};

    if (type.isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    }

    options.type = 'POST';
    return this.ajax(options);
  },

  // 获取文本数据
  getText(url, callback, errorCallback) {
    const options = {
      url,
      dataType: 'text',
      success: callback,
      error: errorCallback
    };
    return this.ajax(options);
  },

  // 获取脚本
  getScript(url, callback) {
    return loader.loadScript(url, callback);
  },

  // get方式 获取json
  getJSON(url, data, callback, errorCallback) {
    const options = {
      url,
      data,
      dataType: 'json',
      success: callback,
      error: errorCallback
    };
    return this.ajax(options);
  },

  /*
    	options:{
    		url:'',//默认当前页面
    		type/method:'',//发起请求的方式，默认get
    		dataType:'',//返回数据的格式，默认json
    		timeout:0,//超时时间,默认不超时
    		async:true,//是否异步，默认异步
    		data:{},//发送的数据，默认为空
    		headers:{},//待发送的header
    		xhrFields:{}//附加到xhr对象上的属性
    		success/done:function(){},
    		error/fail:function(){},
    		complete:function(){}
    	}
    */
  ajax(_url, _options) {
    let url = _url;
    const {
      xhr,
      xmlRequestId
    } = createXMLRequest();
    let options = _options || {};

    if (type.isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    } // url


    options.url = options.url || location.href; // type

    options.type = options.type || options.method || 'GET';
    options.type = options.type.toUpperCase(); // dataType

    options.dataType = options.dataType || 'json'; // timeout

    if (!type.isNumber(options.timeout) || options.timeout < 0) {
      options.timeout = 0;
    } // async


    if (!type.isBoolean(options.async)) {
      options.async = true;
    } // data


    options.data = options.data || {};
    Object.keys(options.data).forEach(k => {
      options.data[k] = encodeURIComponent(options.data[k]);
    });
    /* //判断是否需要csrf
        if ((security_csrf.enable || options.csrf) && false !== options.csrf) {
            let token = security_csrf.setCSRF();
            options.data.iegmilo_csrftoken = token;
        }*/
    // headers

    options.headers = options.headers || {}; // xhrFields

    options.xhrFields = options.xhrFields || {}; // success

    if (!type.isFunction(options.success)) {
      if (type.isFunction(options.done)) {
        options.success = options.done;
      } else {
        options.success = () => {};
      }
    } // fail


    if (!type.isFunction(options.error) && type.isFunction(options.fail)) {
      options.error = (xhr, textStatus, err) => {
        console.log(xhr, textStatus);
        throw err;
      };
    } // complete


    options.complete = type.isFunction(options.complete) ? options.complete : () => {}; // jsonp请求

    let realUrl = options.url;
    let sendData = null;
    let cbName = 'callback';
    let cbVal = `miloJsonpCb_${Math.ceil(100000 * Math.random())}`;

    if ('jsonp' === options.dataType) {
      if (options.callback && type.isString(options.callback)) {
        cbName = options.callback;
      }

      if (options.jsonpCallback && type.isString(options.jsonpCallback)) {
        cbVal = options.jsonpCallback;
      }

      if (realUrl.indexOf('?') > -1) {
        realUrl += `&${cbName}=${cbVal}`;
      } else {
        realUrl += `?${cbName}=${cbVal}`;
      } // data


      Object.keys(options.data).forEach(k => {
        realUrl += `&${k}=${options.data[k]}`;
      });

      window[cbVal] = data => {
        options.success.call(null, data);
      };

      loader.loadScript({
        url: realUrl,
        timeout: options.timeout
      }, isLoad => {
        if (!isLoad) {
          options.error.call(null, null, 'timeout', 'timeout');
        }
      });
      return;
    }

    const arrParams = [];
    Object.keys(options.data).forEach(k => {
      arrParams.push(`${k}=${options.data[k]}`);
    });

    if (arrParams.length) {
      if ('GET' === options.type) {
        if (realUrl.indexOf('?') > -1) {
          realUrl += `&${arrParams.join('&')}`;
        } else {
          realUrl += `?${arrParams.join('&')}`;
        }
      } else if ('POST' === options.type) {
        sendData = arrParams.join('&');
      }
    } // script 请求


    if ('script' === options.dataType) {
      loader.loadScript(realUrl, isLoad => {
        if (!isLoad) {
          options.error.call(null, null, 'timeout', 'timeout');
        } else {
          options.success.call(null);
          options.complete.call(null, 200, 'OK');
        }
      });
      return;
    } // 打开请求


    xhr.open(options.type, realUrl, options.async); // xhrField

    Object.keys(options.xhrFields).forEach(k => {
      xhr[k] = options.xhrField[k];
    }); // headers

    Object.keys(options.headers).forEach(hName => {
      xhr.setRequestHeader(hName, `${options.headers[hName]}`);
    }); // POST

    if ('POST' === options.type) {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    let timeoutTimer = ''; // timeout

    if (options.async && options.timeout > 0) {
      ((_xhr, _xmlRequestId, _options) => {
        timeoutTimer = setTimeout(() => {
          if (_xhr.readyState !== 4) {
            _xhr.abort();

            clearTimeout(timeoutTimer);
          }
        }, _options.timeout);
      })(xhr, xmlRequestId, options);
    } // complete


    const complete = (status, statusText, _response, _responseHeaders) => {
      let responseHeaders = _responseHeaders;
      let response = _response;

      if (200 === status) {
        if (!response) {
          if (type.isString(xhr.responseText)) {
            response = {
              text: xhr.responseText
            };
          } else {
            // binary数据暂不支持处理
            response = {
              binary: xhr.response
            };
          }
        }

        if (!responseHeaders) {
          responseHeaders = xhr.getAllResponseHeaders();
        } // 解析数据


        const {
          data,
          error
        } = parseAjaxData(response, options.dataType);

        if (error) {
          options.error(xhr, statusText, error);
        } else {
          options.success(data, xhr);
        }
      } else {
        options.error(xhr, statusText);
      } // 执行complete


      options.complete(status, statusText, xhr);
    }; // callback


    xmlRequestPool[xmlRequestId].callback = () => type$$1 => {
      if ('error' === type$$1) {
        if (!type$$1.isNumber(xhr.status)) {
          complete(0, 'error');
        } else {
          complete(xhr.status, xhr.statusText);
        }
      } else {
        complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, typeof xhr.responseText !== 'string' ? {
          binary: xhr.response
        } : {
          text: xhr.responseText
        }, xhr.getAllResponseHeaders());
      }
    };

    const {
      callback
    } = xmlRequestPool[xmlRequestId];
    xhr.onload = callback();
    xhr.ontimeout = callback('error');
    xhr.onerror = xhr.ontimeout;
    const errorCallback = xhr.onerror; // event

    if (xhr.onabort !== undefined) {
      xhr.onabort = errorCallback;
    } else {
      xhr.onreadystatechange = () => {
        if (4 === xhr.readyState) {
          if (callback) {
            errorCallback();
          }
        }
      };
    } // 发送请求


    xhr.send(sendData);
    return xhr;
  }

};

const backend = {
  type: 'backend',
  backendOptions: {
    sCdnPrefix: 'https://ossweb-img.qq.com/images/js/ti18n/resource' // 远程资源的CDN地址前缀，cdn地址为`${sCdnPrefix}/${appid}/${ns}/${lng}.js`

  },
  i18nServices: {},
  i18nOptions: null,

  init(services, oBackendOptions, options = {}) {
    this.i18nServices = services || {};
    this.backendOptions = { ...this.backendOptions,
      ...oBackendOptions
    };
    this.i18nOptions = options;

    if (!this.backendOptions.appid || !this.i18nOptions.appid) {
      if (services.backendConnector) {
        services.backendConnector.emit('backend-error', {
          sMsg: 'appid lost when init backend',
          sErrType: 'init'
        });
      }
    }

    if (!this.backendOptions.sCdnPrefix) {
      if (services.backendConnector) {
        services.backendConnector.emit('backend-error', {
          sMsg: 'sCdnPrefix lost when init backend',
          sErrType: 'init'
        });
      }
    }
  },

  read(lng, ns, callback) {
    if (!lng || !ns) {
      callback && callback(new Error('lng or ns param lost'));
      return;
    }

    const appid = this.backendOptions.appid || this.i18nOptions.appid || '';
    const sCdnPrefix = this.backendOptions.sCdnPrefix || '';

    if (!appid) {
      callback && callback(new Error(`appid lost when read backend resource for lng:${lng} and ns:${ns}`));
      return;
    }

    if (!sCdnPrefix) {
      callback && callback(new Error(`sCdnPrefix lost when read backend resource for lng:${lng} and ns:${ns}`));
      return;
    }

    let resourceUrl = ''; // 如果传了版本号，则使用新的cdn路径规则(里面带版本号)

    const sVersion = this.backendOptions.sVersion ? `/${this.backendOptions.sVersion}` : '';

    if (/\/$/.test(sCdnPrefix)) {
      resourceUrl = `${sCdnPrefix}ti18n/${appid}${sVersion}/${ns}/${lng}.js`;
    } else {
      resourceUrl = `${sCdnPrefix}/ti18n/${appid}${sVersion}/${ns}/${lng}.js`;
    } // 为了防止跨域，这里采用的是script的加载方式


    network.getScript(resourceUrl, isLoad => {
      if (!isLoad) {
        callback && callback(new Error(`request resource for ns:${ns} lng:${lng} fail:ajax fail`));
        return;
      }

      const data = window[`TI18N_RESOURCE_${appid}_${ns}_${lng}`];
      callback && callback(null, data);
    });
    /* network.getJSON(resourceUrl, {}, (jsonData) => {
      callback && callback(null, jsonData);
    }, () => {
      callback && callback(new Error(`request resource for ns:${ns} lng:${lng} fail:ajax fail`));
    });*/
  }

};

/*
存储数据格式：
ti18ncache_{key}:

JSON.stringify({
	data:data,//数据
	expiresTime:timeStamp//过期时间
})
*/

const cache = {
  type: 'cache',
  oCacheParams: {
    iEnabled: true,
    // 是否开启，默认开启
    expires: 86400 // 默认缓存为1天

  },
  i18nServices: null,
  i18nOptions: null,

  init(services, oCacheOptions, options = {}) {
    this.i18nServices = services || {};
    this.oCacheParams = { ...this.oCacheParams,
      ...oCacheOptions
    };
    this.i18nOptions = options;

    if (!this.oCacheParams.expires) {
      this.oCacheParams.expires = 86400;
    }
  },

  isEnableCache() {
    const {
      iEnabled
    } = this.oCacheParams;

    if (true === iEnabled) {
      return true;
    }

    return false;
  },

  set(oParams = {}, callback) {
    const {
      expires
    } = this.oCacheParams; // 不使用缓存

    if (!this.isEnableCache()) {
      callback && callback(null);
      return;
    }

    const {
      cacheKey,
      data
    } = oParams;

    if (!cacheKey) {
      callback && callback('no cacheKey');
      return;
    }

    const sKey = `ti18ncache_${cacheKey}`;
    const oData = {
      data,
      expiresTime: expires * 1000 + new Date().getTime() // ms

    };
    const sData = JSON.stringify(oData);
    const res = storage.set(sKey, sData);

    if (res) {
      callback && callback(res);
    } else {
      callback(null);
    }
  },

  get(cacheKey, callback) {
    // 不使用缓存
    if (!this.isEnableCache()) {
      callback && callback('cache not enabled');
      return;
    }

    if (!cacheKey) {
      callback && callback('param cacheKey lost');
      return;
    }

    const sKey = `ti18ncache_${cacheKey}`;
    const sRes = storage.get(sKey);

    if (sRes instanceof Error) {
      callback && callback(sRes.toString());
      return;
    }

    if (!sRes) {
      callback && callback('cache not found');
      return;
    }

    let oRes = null;

    try {
      oRes = JSON.parse(sRes);
    } catch (err) {
      callback && callback(err);
      return;
    }

    const {
      expiresTime,
      data
    } = oRes; // 过期了

    if (expiresTime && expiresTime < new Date().getTime()) {
      callback && callback('cache expired time');
      return;
    }

    callback && callback(null, data);
  }

};

/*
@module webSDKCore
@description 提供web页面上使用的i18n通用组件，包含了默认的languageDetector，cache，backend，为react，vue，jquery-sdk等提供服务
*/

class WebSDKCore {
  constructor() {
    const instance = i18nCore.createInstance(); // use languageDetector

    instance.use(languageDetector); // use backend

    instance.use(backend); // use cache

    instance.use(cache);
    return instance;
  }

}

var webSDKCore = new WebSDKCore();

export default webSDKCore;
